import { create } from 'zustand';
//import axios from 'axios';
import api from '../axios/axiosInstance';

const useTokenStore = create((set) => ({
    balance: null,
    loading: false,
    error: null,

    fetchTokenBalance: async () => {
        set({ loading: true });

        try {
            const response = await api.get(`${process.env.REACT_APP_BACKEND_URL}/auth/profile/`, {
                withCredentials: true,  // ✅ Required for sending cookies
            });

            const tokens = response.data.tokens_remaining;
            set({ balance: tokens ?? 0, loading: false });
        } catch (error) {
            // Error handled silently
            set({ error, loading: false });
        }
    },
}));

export default useTokenStore;
